import React from 'react'
import './product.css';
export const Product = () => {
  return (
    <div className='p'>
        <div className="p-browser">
            <div className="p-circle"></div>
            <div className="p-circle"></div>
            <div className="p-circle"></div>
        </div>
        <a href="https://ibb.co/qCFczP1"><img src="https://i.ibb.co/r4LN2g2/screencapture-fervent-spence-ac9685-netlify-app-2022-05-19-22-15-31.png" alt="1652975876705" border="0" className='p-img' /></a>
    </div>
  )
}
